import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./ficha-alumno.component.html")
const fichaConfig = require("../../ficha-alumno.config.json")

angular.module("fichaAlumnoModule").component("fichaAlumno", {
  templateUrl: templateUrl,
  controller: [
    "$http",
    "$stateParams",
    "AlumnoService",
    "MatriculaService",
    "formularioService",
    "PeriodoService",
    "ComentarioService",
    function FichaAlumnoController(
      $http,
      $stateParams,
      AlumnoService,
      MatriculaService,
      formularioService,
      PeriodoService,
      ComentarioService
    ) {
      var self = this
      self.tabs = {
        selectedIndex: 0
      }

      self.refreshComentarios = 0

      self.indicadores = {
        desercion: {
          type: "percent",
          class: "kpi",
          title: "Riesgo Deserción",
          value: 0
        },
        riesgo: {
          type: "text",
          class: "system",
          title: "Nivel de Riesgo",
          value: "",
          fontSize: "medium"
        },
        alertas: {
          type: "number",
          class: "system",
          title: "Alertas Activas",
          value: 2
        },
        pendientes: {
          type: "number",
          class: "system",
          title: "Atención Pendiente",
          value: 1
        }
      }

      self.$onInit = function() {
        self.alumnoId = $stateParams.alumnoId
        self.loadAlumno()
      }

      self.getDatosEditables = function(fichaDatos) {
        var i, j, l, result, item

        result = [{ label: "nombre", value: "nombre" }]

        for (i = 0; i < fichaDatos.length; i++) {
          l = fichaDatos[i]["fields"].length
          for (j = 0; j < l; j++) {
            item = fichaDatos[i]["fields"][j]

            // Normalize field names
            if (item.value) {
              item.value = item.value.toLowerCase()
            }

            if (item["editable"]) {
              result.push(item)
            }
          }
        }
        return result
      }

      self.loadAlumno = function() {
        AlumnoService.get({ alumno: self.alumnoId })
          .$promise.then(function(data) {
            self.alumno = data
            self.alumnoId = data.id
            self.crearAtenciones = 0
            self.crearAlertas = 0

            self.setMatriculaActiva()

            self.fichaDatos = fichaConfig["ficha-datos"]
            self.datosEditables = self.getDatosEditables(self.fichaDatos)
          })
          .catch(function() {
            self.error = "No se encontró la ficha del estudiante"
          })
      }

      self.setMatriculaActiva = function() {
        var matriculas = self.alumno.matriculas
        var riesgo
        PeriodoService.get_periodo_actual().then(function(periodo_activo) {
          for (var i = 0; i < matriculas.length; i++) {
            // console.log(matriculas[i]);
            if ("" + matriculas[i].periodo_id === "" + periodo_activo.id) {
              self.matricula_activa = matriculas[i]
              self.indicadores.desercion.value =
                self.matricula_activa.atributos.probabilidad_desercion

              riesgo = self.matricula_activa.atributos.decil_riesgo
              riesgo = riesgo < 5 ? "BAJO" : riesgo < 9 ? "MEDIO" : "ALTO"
              self.indicadores.riesgo.value = riesgo
              self.indicadores.riesgo.color =
                riesgo == "BAJO" ? "#009688" : riesgo == "MEDIO" ? "#dec91c" : "#e83834"
              self.indicadores.riesgo.titleColor =
                riesgo == "BAJO" ? "#24a99c" : riesgo == "MEDIO" ? "#e8d745" : "#ec5451"
            }
          }
        })
      }

      self.getDataSource = function(modelName) {
        switch (modelName) {
          case "alumno":
            return self.alumno
          case "matricula":
            return self.matricula_activa
          case "matricula.atributos":
            return self.matricula_activa.atributos
          case "alumno-extendido":
            var extended = Object.assign(
              self.alumno,
              self.matricula_activa,
              self.matricula_activa.atributos
            )
            extended["id"] = self.alumnoId
            return extended
          default:
            return {}
        }
      }

      self.getNotas = function() {
        var data_source = self.getDataSource("alumno-extendido")
        var notas = data_source.notas || []

        var notas_agregadas = {}
        for (var i = 0; i < notas.length; i++) {
          asignatura = notas[i].codigo
          nota = notas[i].nota
          corte = notas[i].corte

          if (!(asignatura in notas_agregadas)) {
            notas_agregadas[asignatura] = notas[i]
            notas_agregadas[asignatura][corte] = nota
          } else {
            notas_agregadas[asignatura][corte] = nota
          }
        }

        data_source.atributos.notas = Object.values(notas_agregadas)
        return data_source
      }

      self.editarAntecedentes = function(post_data) {
        return AlumnoService.update({ alumno: post_data.id }, post_data)
          .$promise.then(function(data) {
            self.loadAlumno()
          })
          .catch(function() {
            self.error = "No se encontró la ficha del estudiante"
          })
      }

      self.editarEstado = function(post_data) {
        var comentario =
          "Cambio Estado Ficha (" + post_data.estado_desc + "): " + post_data.comentario
        var comment = {
          object_pk: post_data.id,
          modelName: "matricula",
          comment: comentario
        }

        console.log(post_data)
        MatriculaService.update({
          id: post_data.id,
          estado_id: post_data.estado_id
        }).$promise.then(function(data) {
          self.loadAlumno()
        })

        ComentarioService.save(comment).$promise.then(function(data) {
          console.log(data)
          self.refreshComentarios += 1
        })
      }

      // Utility to show
      self.showForm = function($event, modelName, actionName, locals) {
        formularioService.showPopup(
          $event,
          {
            modelName: modelName,
            actionName: actionName
          },
          locals
        )
      }

      // Handler for click on "edit"
      self.antecedentesForm = function($event) {
        // Data to be passed to the modal
        var alumno = Object.assign(
          JSON.parse(JSON.stringify(self.alumno)),
          self.matricula_activa,
          self.matricula_activa.atributos
        )

        // Force ID attribute
        alumno["id"] = self.alumnoId

        self.showForm($event, "antecedentes", "editar", {
          alumno: alumno,
          datosEditables: self.datosEditables,
          saveCallback: self.editarAntecedentes
        })
      }

      //falta implementar backend para cambio de estado de matricula
      self.matriculaForm = function($event) {
        self.showForm($event, "matricula", "estado", {
          alumno: self.matricula_activa,
          saveCallback: self.editarEstado
        })
      }

      self.goToComentarios = function() {
        self.tabs.selectedIndex = 5
      }

      self.crearRegistro = function(modelName) {
        switch (modelName) {
          case "alertas":
            self.crearAlertas += 1
            break
          default:
            self.crearAtenciones += 1
        }
      }

      self.refreshComentariosCallback = function() {
        self.refreshComentarios += 1
      }
    }
  ]
})
